<template lang="pug">
div
  .form-group(:class="{ 'form-group__invalid': v$.inputValue.$errors.length }")
    .label {{ value.name }}
    select(
      v-if="disabled"
      :disabled="true" 
    )
      option {{ value.value }}
    select(
      v-else 
      @change="sendAnswer(value, $event.target.value)"
      v-model="inputValue"
      @blur="v$.inputValue.$touch()"
    )
      option(value="") Please select
      option(v-for="option in value.options" :key="option.id" :value="option.name" ) {{ option.name }}
    .form-group__errors(v-if="v$.inputValue.$dirty && v$.inputValue.$errors.length")
      .form-group__error(v-if="v$.inputValue.required.$invalid") Field is required!

</template>
<script>
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default defineComponent({
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    let args = {
      inputValue: {},
    };
    if (this.value.required) {
      args = {
        inputValue: {
          required,
        },
      };
    }
    return args;
  },
  data() {
    return {
      inputValue: "",
    };
  },
  methods: {
    sendAnswer(value, eventTarget) {
      this.$emit("emitAnswer", value, eventTarget);
    },
  },
  emits: ["emitAnswer"],

  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    default: {
      type: String,
      required: false,
    },
  },
  created() {
    if (this.value === null) return;
    if (this.default === null) {
      this.inputValue = "";
    } else { 
      this.inputValue = this.default;
    }
  },
});
</script>
